import React from "react";

const Modal = ({
  title,
  body,
  setShow,
  setConfirm,
  setbackground,
  cancelbtn,
  confirmbtn,
  secondarybtn,
  setSecondary,
}) => {
  return (
    <div className="modalbackdrop">
      <div
        className="absolute top-1/2 bg-white p-5 left-1/2 min-w-[400px] w-fit shadow-commonshadow border-[1px] border-commonborder rounded-[12px]"
        style={{ transform: "translate3d(-50%, -50%, 0)" }}
      >
        <div className="text-left text-18 font-semibold">
          <h1>{title}</h1>
        </div>
        <div className="px-4 py-3 text-left">
          <p>{body}</p>
        </div>
        <div className="flex gap-5 mt-5 justify-end">
          <button
            onClick={() => {
              setShow(false);
            }}
            className="p-2"
          >
            {cancelbtn}
          </button>
          {secondarybtn && (
            <button
              onClick={() => {
                setShow(false);
                setSecondary && setSecondary();
              }}
              className="p-2 bg-[#07bc0c] rounded-[8px] text-white"
            >
              {secondarybtn}
            </button>
          )}
          <button
            onClick={() => {
              setbackground && setbackground(true);
              setShow(false);
              setConfirm();
            }}
            className="p-2 bg-[#07bc0c] rounded-[8px] text-white"
          >
            {confirmbtn}
          </button>
        </div>
      </div>
      <hr></hr>
    </div>
  );
};

export default Modal;
